import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import classes from "./homeVideoSection.module.scss";

const videoExtensions = [".mp4", ".webm", ".ogg"];

const HomeVideoSection = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const data = window.homeVideoSection || {};
  const mediaSrc = data.mediaSrc || "";
  const isVideo = videoExtensions.some((ext) => mediaSrc.endsWith(ext));

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => { });
        } else {
          video.pause();
        }
      },
      { threshold: 0.3 }
    );

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);
    video.addEventListener("play", handlePlay);
    video.addEventListener("pause", handlePause);

    observer.observe(video);
    return () => {
      observer.disconnect();
      video.removeEventListener("play", handlePlay);
      video.removeEventListener("pause", handlePause);
    };
  }, []);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => { });
    } else {
      video.pause();
    }
  };

  return (
    <section className={classes.videoSection}>
      <div className={classes.bgWrapper}>
        <figure>
          {isVideo ? (
            <video ref={videoRef} loop muted playsInline poster={data.posterImg || ""}>
              <source src={mediaSrc} />
            </video>
          ) : (
            <img
              src={mediaSrc}
              alt="Make every moment special"
              loading="lazy"
            />
          )}
        </figure>
      </div>
      <div className={classes.overlay} />
      {isVideo && (
        <button
          className={classes.playPauseBtn}
          onClick={togglePlay}
          aria-label={isPlaying ? "Pause video" : "Play video"}
        >
          {isPlaying ? (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect x="3" y="2" width="5" height="16" rx="1" fill="#fff" />
              <rect x="12" y="2" width="5" height="16" rx="1" fill="#fff" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4 2L18 10L4 18V2Z" fill="#fff" />
            </svg>
          )}
        </button>
      )}
      <div className={classes.content}>
        <h2 className={`${classes.title} uk-padding-remove`}>
          {data.title}
        </h2>
        <p className={classes.description}>
          {data.description}
        </p>
        <Link
          to={`${process.env.PUBLIC_URL}${data.link || "/jewellery"}`}
          className={classes.btn}
        >
          {data.buttonText}
        </Link>
      </div>
    </section>
  );
};

export default HomeVideoSection;
